import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";

import { EncargadoService } from "app/main/apps/shared/services/rest/encargado.service";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import {
    NuevoEncargadoDTO,
    PermisosDTO,
} from "app/main/apps/shared/models/encargado.model";
import { DialogUsuarioComponent } from "../dialog-usuario/dialog-usuario.component";
import { Subscription } from "rxjs";
import { SucursalesService } from "app/main/apps/shared/services/rest/sucursales.service";
import { SucursalPersonaDTO } from "app/main/apps/shared/interfaces/sucursal-persona.interface";
import { fuseAnimations } from "@fuse/animations";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { finalize } from "rxjs/operators";


@Component({
    selector: "app-encargado",
    templateUrl: "./encargado.component.html",
    styleUrls: ["./encargado.component.scss"],
    animations: fuseAnimations,
})
export class EncargadoComponent implements OnInit, OnDestroy {
    esRepresentante:boolean=false;
    esSupervisor:boolean=false;
    public idSucursal: number;
    public idCliente: number;
    public encargados: NuevoEncargadoDTO[];
    public sucursal: SucursalPersonaDTO;

    private subscripciones: Subscription;

    constructor(
        private _activatedRouteSrv: ActivatedRoute,
        private _encargadoSrvc: EncargadoService,
        private _location: Location,
        private _dialogSrvc: DialogService,
        private _sucursalSrvc: SucursalesService,
        private _notificacionesSrvc: NotificacionesService,
        private _menuUsuarioSrvc:MenuUsuarioService,
        private _fuseProgressBarService: FuseProgressBarService,
    ) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {

        this.esRepresentante=this._menuUsuarioSrvc.esRepresentante();
        this.esSupervisor=this._menuUsuarioSrvc.esSupervisor();

        this.subscripciones.add(
            this._activatedRouteSrv.params.subscribe((params) => {
                if (Object.keys(params).length > 0) {
                    this.idSucursal = params["idSucursal"];
                    this.idCliente = params["idCliente"];
                    this.obtenerEncargados();
                    this.obtenerSucursal();
                }
            })
        );
    }

    obtenerEncargados() {
        this.subscripciones.add(
            this._encargadoSrvc
                .fetchEncargadosSucursal(this.idSucursal)
                .subscribe((resp) => {
                    this.encargados = resp;
                })
        );
    }

    obtenerSucursal() {
        this.subscripciones.add(
            this._sucursalSrvc
                .fetchSucursal(this.idCliente, this.idSucursal)
                .subscribe((resp) => {
                    //console.log(resp);
                    this.sucursal = resp;
                })
        );
    }

    volver() {
        this._location.back();
    }

    borrarEncargado(event): void {
        //console.log(event);
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Eliminar Encargado",
            "Favor confirme si realmente quiere realizar la eliminación del encargado "
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._fuseProgressBarService.show();
                this._encargadoSrvc
                    .delete(this.idSucursal, event.split("-")[0])
                    .pipe(finalize(()=>{this._fuseProgressBarService.hide();}))
                    .subscribe((resp) => {
                        this.encargados = null;
                        this.obtenerEncargados();
                    });
            }
        });
    }

    editarEncargado(event) {
        //console.log(event);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogUsuarioComponent,
            "clase-dialog",
            "500px",
            {
                esEncargado: true,
                editar: true,
                usuario: event,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._fuseProgressBarService.show();
                let nuevoPermiso = new PermisosDTO(
                    result.puedeCotizar == null ? false : result.puedeCotizar,
                    result.puedeComprar == null ? false : result.puedeComprar,
                    result.puedeRecibir == null ? false : result.puedeRecibir
                );

                let nuevoEncargado = new NuevoEncargadoDTO(
                    result.rut.split("-")[0],
                    result.rut.split("-")[1],
                    result.nombres,
                    result.apellidos,
                    nuevoPermiso,
                    result.correo
                );

                this.subscripciones.add(
                    this._encargadoSrvc
                        .save(this.idSucursal, nuevoEncargado)
                        .pipe(finalize(()=>{this._fuseProgressBarService.hide();}))
                        .subscribe((resp) => {
                            this.encargados = null;
                            this.obtenerEncargados();
                            this._notificacionesSrvc.mostrarNotificacion(
                                "Usuario modificado con exito",
                                "success"
                            );
                        })
                );
            }
        });
    }

    nuevoEncargado() {
        //console.log(event);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogUsuarioComponent,
            "clase-dialog",
            "500px",
            {
                esEncargado: true,
                idSucursal: this.idSucursal,
                editar: false,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._fuseProgressBarService.show();
                let nuevoPermiso = new PermisosDTO(
                    result.puedeCotizar == null ? false : true,
                    result.puedeComprar == null ? false : true,
                    result.puedeRecibir == null ? false : true
                );

                let nuevoEncargado = new NuevoEncargadoDTO(
                    result.rut.split("-")[0],
                    result.rut.split("-")[1],
                    result.nombres,
                    result.apellidos,
                    nuevoPermiso,
                    result.correo
                );

                this.subscripciones.add(
                    this._encargadoSrvc
                        .save(this.idSucursal, nuevoEncargado)
                        .pipe(finalize(()=>{this._fuseProgressBarService.hide();}))
                        .subscribe((resp) => {
                            this.encargados = null;
                            this.obtenerEncargados();
                            this._notificacionesSrvc.mostrarNotificacion(
                                "Usuario creado con exito",
                                "success"
                            );
                        })
                );
            }
        });
    }
    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
